__webpack_require__.p = "https://cdn.splashmath.com/school_ui/assets/";